export class MonitoredArea {
	constructor(
		readonly id: string,
		readonly name: string,
		readonly geojson: object,
		readonly buffer?: object,
	) {}
}
